<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'userManagementPowerModel',
})
</script>
<template>
  <ant-Modal v-model:open="state.model.visible" :centered="true" :maskClosable="false" :closable="false"
    :title="state.model.title" :width="state.model.width" :confirm-loading="state.loading.submit" :keyboard="false"
    :ok-text="state.model.submitTxt" @ok="onSubmit" @cancel="closeDialog">
    <div class="form-content">
      <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules" :wrapper-col="{ style: 'flex: 1' }">
        <a-form-item label="角色" name="roleId">
          <a-select v-model:value="state.ruleForm.roleId" placeholder="请选择角色" allow-clear>
            <a-select-option v-for="item in state.roleList" :key="item.code" :value="item.code">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="userManagementPowerModel">
import { reactive, ref, nextTick, onMounted } from 'vue'
import { cloneDeep } from 'lodash-es'
import { useMember } from '@/store/system/member'
import { useUser } from '@/store/user'
import { message } from 'ant-design-vue'
const userApi = useUser()
const memberStore = useMember()

const emit = defineEmits(['updatePage'])

const formRef = ref()

const emptyForm = {
  id: '',
  roleId: undefined as string | undefined
}

const state = reactive({
  ruleForm: cloneDeep(emptyForm),
  rules: {
    roleId: [{ required: true, message: '请选择角色', trigger: 'change' }]
  },
  model: {
    visible: false,
    title: '',
    submitTxt: '',
    width: '517px'
  },
  loading: {
    submit: false
  },
  roleList: []
})

const openDialog = (record) => {
  console.log(record, 'record')
  state.model.visible = true
  nextTick(() => {
    state.ruleForm = cloneDeep(emptyForm)
    state.ruleForm.id = record.id
    state.ruleForm.roleId = record.roleId || undefined as string | undefined
    state.model.title = '权限分配'
    state.model.submitTxt = '确认'
  })
}

const closeDialog = () => {
  state.model.visible = false
  state.loading.submit = false
  state.ruleForm = cloneDeep(emptyForm)
  formRef.value?.resetFields()
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(async () => {
      try {
        state.loading.submit = true
        await userApi.changeConfRoleId(state.ruleForm)
        message.success('用户权限分配成功')
        closeDialog()
        state.loading.submit = false
        emit('updatePage')
      } catch (error) {
        state.loading.submit = false
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

onMounted(async () => {
  state.roleList = (await memberStore.getNameTag()) as any
})

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 30px 36px 32px 36px;
}

// ===== 表单 =====
:deep(.ant-form-item) {
  margin-bottom: 0px;
  padding-bottom: 24px;
}

:deep(.ant-form-item-label) {
  margin-left: 0px;
  margin-right: 5px;
  width: 50px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}
</style>
